<template>
  <b-sidebar
    id="sidebar-right-order"
    :width="width"
    right
    backdrop
    body-class="p-0"
    no-header
    no-close-on-backdrop
    no-close-on-route-change
    lazy
    @hidden="closeOrderWidget"
  >
    <template #default="{ hide }">
      <div class="detail-widget">
        <div class="detail-widget__field detail-widget__left">
          <div class="detail-widget__top">
            <b-icon-arrow-bar-left
              class="detail-widget__back cursor-pointer"
              font-scale="2"
              @click="hide"
            ></b-icon-arrow-bar-left>
            <b-skeleton-wrapper :loading="isLoading">
              <template #loading>
                <b-skeleton height="35px"></b-skeleton>
                <b-skeleton class="mt-2" height="30px"></b-skeleton>
              </template>

              <div class="top">
                <h2 class="title text-light mb-0">{{ items.reference_order_type_id == 1 ? "Заявка" : "Поставка" }} #{{ items.id }}</h2>
                <div class="buttons">
                  <b-button @click="refreshOrder" size="sm" variant="outline-light">
                    <b-icon
                      icon="arrow-repeat"
                      scale="1.5"
                      aria-label="Reload"
                      :animation="isLoading ? 'spin' : ''"
                    ></b-icon>
                  </b-button>
                </div>
              </div>
              <div class="d-flex justify-content-between align-items-center mt-2">
                <h3 class="subtitle text-light mb-0">
                  {{ companyName ? companyName : "..." }}
                </h3>
              </div>
            </b-skeleton-wrapper>

            <button
              class="detail-widget__top-copy-button"
              @click="copyLink"
            >
              <b-icon
                icon="link45deg"
                scale="2"
              ></b-icon>
            </button>
          </div>

          <div class="detail-widget__card">
            <b-overlay class="h-100" :show="isLoading">
              <template v-if="items.id">
                <b-tabs
                  lazy
                  nav-class="nav-widget"
                  nav-wrapper-class="p-0"
                >
                  <b-tab @click="deleteQueryTab">
                    <template #title>
                      <div>Детали</div>
                    </template>
                    <tsoft-order-details-client
                      :detailedItem="items"
                      @changeOrderScore="changeOrderScore"
                    />
                  </b-tab>

                  <b-tab
                    v-if="quotationVisible && items.set_services_ids.includes(22)"
                    :active="orderTab === '22'"
                    @click="setRefreshKey"
                  >
                    <template #title>
                      <div>Таможенное оформление</div>
                    </template>
                    <tsoft-order-service-details-client
                      :key="refreshKey"
                      :order_id="items.id"
                      :reference_service_id="22"
                      @setServiceInfo="setServiceInfo"
                    />
                  </b-tab>

                  <b-tab
                    v-if="quotationVisible && items.set_services_ids.includes(24) && isTestMode"
                    :active="orderTab === '24'"
                    @click="setRefreshKey"
                  >
                    <template #title>
                      <div>Сертификация</div>
                    </template>
                    <tsoft-order-service-details-client
                      :key="refreshKey"
                      :order_id="items.id"
                      :reference_service_id="24"
                      @setServiceInfo="setServiceInfo"
                    />
                  </b-tab>

                  <b-tab
                    v-if="quotationVisible && items.set_services_ids.includes(25) && isTestMode"
                    :active="orderTab === '25'"
                    @click="setRefreshKey"
                  >
                    <template #title>
                      <div>Консалтинг и сопутсвующие услуги</div>
                    </template>
                    <tsoft-order-service-details-client
                      :key="refreshKey"
                      :order_id="items.id"
                      :reference_service_id="25"
                      @setServiceInfo="setServiceInfo"
                    />
                  </b-tab>

                  <b-tab
                    v-if="quotationVisible && items.set_services_ids.includes(23)"
                    :active="orderTab === '23'"
                    @click="setRefreshKey"
                  >
                    <template #title>
                      <div>Логистика</div>
                    </template>
                    <tsoft-order-service-details-client
                      :key="refreshKey"
                      :order_id="items.id"
                      :reference_service_id="23"
                      @setServiceInfo="setServiceInfo"
                    />
                  </b-tab>

                  <b-tab
                    v-if="quotationVisible && items.set_services_ids.includes(75) && isTestMode"
                    :active="orderTab === '75'"
                    @click="setRefreshKey"
                  >
                    <template #title>
                      <div>ПНК</div>
                    </template>
                    <tsoft-order-service-details-client
                      :key="refreshKey"
                      :order_id="items.id"
                      :reference_service_id="75"
                      @setServiceInfo="setServiceInfo"
                    />
                  </b-tab>

                  <b-tab
                    v-if="quotationVisible && items.set_services_ids.includes(76) && isTestMode"
                    :active="orderTab === '76'"
                    @click="setRefreshKey"
                  >
                    <template #title>
                      <div>СВХ</div>
                    </template>
                    <tsoft-order-service-details-client
                      :key="refreshKey"
                      :order_id="items.id"
                      :reference_service_id="76"
                      @setServiceInfo="setServiceInfo"
                    />
                  </b-tab>

                  <b-tab
                    v-if="quotationVisible && items.set_services_ids.includes(77) && isTestMode"
                    :active="orderTab === '77'"
                    @click="setRefreshKey"
                  >
                    <template #title>
                      <div>Страхование</div>
                    </template>
                    <tsoft-order-service-details-client
                      :key="refreshKey"
                      :order_id="items.id"
                      :reference_service_id="77"
                      @setServiceInfo="setServiceInfo"
                    />
                  </b-tab>

                  <b-tab
                    :active="orderTab === 'order-documents'"
                    v-if="!items.short_order"
                  >
                    <template #title>
                      <div>Документы</div>
                    </template>

                    <h5 class="mt-3 mb-2">Мои документы</h5>
                    <tsoft-show-edit-documents-client
                      :orderId="items.id"
                      :companyId="items.company_id"
                      :referenceDocumentTypeIds="[337]"
                      :updateListDocument="singleOrMultiDocuments"
                      @clearDocumentList="clearDocumentList"
                      requestDocuments
                    />
                    <tsoft-create-documents
                      :orderId="items.id"
                      :companyId="items.company_id"
                      :needMultiUploadDocuments="true"
                      :onlyMultiUploadDocuments="true"
                      :onlySmallScreenMultiUpload="true"
                      @updateViewDocument="documentOutput"
                    />

                    <div v-if="quotationVisible" class="mt-5">
                      <h5 class="mb-2">
                        {{ items.reference_order_type_id == 1 ? "Коммерческое предложение" : "Документы компании" }}
                      </h5>
                      <tsoft-show-edit-documents-client
                        :orderId="items.id"
                        :companyId="items.company_id"
                        :referenceDocumentTypeIds="[334]"
                        requestDocuments
                      />
                    </div>

                    <div
                      class="document_view_order mt-5"
                      v-if="items.reference_order_type_id == 2 && items.company_id && documentIdsFromCompany.length > 0"
                    >
                      <h5>Документы по услугам в компании</h5>
                      <tsoft-show-edit-documents-client
                        :companyId="items.company_id"
                        :referenceDocumentTypeIds="documentIdsFromCompany"
                        :updateDocumentList="documentIdsFromCompany.length"
                        :noActions="true"
                        requestDocuments
                      />
                    </div>
                  </b-tab>

                  <b-tab
                    :active="orderTab === 'order-finance'"
                    v-if="items.reference_order_type_id == 2"
                  >
                    <template #title>
                      <div>Счета</div>
                    </template>
                    <tsoft-finance-finder-creator-client
                      id="invoiceToOrder"
                      :exportXLSX="`Счета по поставке #${items.id}`"
                      :order_id="items.id"
                      :company_id="items.company_id"
                      :allowed_services="items.services"
                      :full_order="items"
                      :additionalGetParameter="`&order_id=${items.id}`"
                      typeOfTableFilter="finance"
                      :isNeedCreate="false"
                    >
                    </tsoft-finance-finder-creator-client>
                  </b-tab>
                </b-tabs>
              </template>
            </b-overlay>
          </div>
        </div>
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import {
  API_ORDERS,
  SERVICE_TO_DOCUMENT,
} from "@/constants";

import tsoftOrderServiceDetails from "@components/orders/OrderServiceDetails";
import tsoftOrderServiceDetailsClient from "@components/orders/OrderServiceDetailsClient";
import tsoftFinanceFinderAndCreatorClient from "@components/finance/FinanceFinderAndCreatorClient";
import tsoftOrderDetailsClient from "@components/orders/OrderDetailsClient";
import tsoftOrderOutsourcing from "@components/orders/OrderOutsourcing";

import { mixinDocuments } from "@/mixins/mixinDocuments";
import { orderMethods, defaultDataItems, copyLink } from "@/mixins";

export default {
  components: {
    "tsoft-order-details-client": tsoftOrderDetailsClient,
    "tsoft-order-service-details": tsoftOrderServiceDetails,
    "tsoft-order-service-details-client": tsoftOrderServiceDetailsClient,
    "tsoft-finance-finder-creator-client": tsoftFinanceFinderAndCreatorClient,
    tsoftOrderOutsourcing,
  },

  mixins: [
    mixinDocuments,
    orderMethods,
    defaultDataItems,
    copyLink,
  ],

  metaInfo() {
    return {
      title: `Поставка #${this.orderID}`,
    };
  },

  props: {
    width: {
      type: String,
      require: true,
    }
  },

  data() {
    return {
      items: {},
      isLoading: true,
      editOrderData: {},
      refreshKey: 0,
      saving: false,
      files: [],
      allUsersFromOrder: [],
      apiName: 'order',
      idName: 'order_id',
      isTestMode: false       // Активировать недоступные клиенту фичи
    };
  },

  watch: {
    orderID(value) {
      if (!!value) {
        this.refreshOrder();
      }
    },
  },

  computed: {
    ...mapGetters("auth", ["currentUser"]),

    orderID() {
      return this.$route.query.order;
    },

    orderTab() {
      return this.$route.query['tab-order'];
    },

    companyName() {
      return this.items.company && this.items.company.name
        ? this.items.company.name
        : this.items.temp_name;
    },

    documentIdsFromCompany() {
      return this.items.set_services_ids.map((id) => SERVICE_TO_DOCUMENT[id]);
    },

    quotationVisible() {
      if (this.items.reference_order_type_id == 2) {
        return true;
      }
      return [543, 544, 545].includes(this.items.reference_status_id);
    },

    currentId() {
      return this.$route.query.order;
    },
  },

  methods: {
    ...mapActions(["GET_REFERENCE_PROPERTIES"]),
    ...mapActions("orderDetail", [
      "orderWidgetSetValue",
      "orderWidgetSetStatus",
      "orderWidgetSetScore",
    ]),

    async getOrder() {
      const { data } = await axios.get(`${API_ORDERS}/${this.orderID}`);
      this.items = data;
      this.getAllUsersFromOrderForNotificationList()
    },

    setServiceInfo(service_id, data) {
      if (!this.items.services_info) {
        this.$set(this.items, "services_info", {});
      }
      this.items.services_info[service_id] = data;
    },

    setRefreshKey() {
      this.refreshKey++;
    },

    refreshOrder() {
      this.isLoading = true;

      Promise.all([this.getOrder()]).then(() => {
        this.isLoading = false;
      });
    },

    closeOrderWidget() {
      const query = Object.assign({}, this.$route.query);
      delete query['edit-order'];
      delete query['tab-order'];
      delete query.order;
      this.$router.replace({ query });
      this.orderWidgetSetStatus("closed");
    },

    deleteQueryTab() {
      if (this.$route.query['tab-order']) {
        const query = Object.assign({}, this.$route.query);
        delete query['tab-order'];
        this.$router.replace({ query });
      }
    },

    getAllUsersFromOrderForNotificationList() {
      if (this.items.id) {
        if (this.currentUser.id) { this.allUsersFromOrder.push({ name: this.currentUser.name, value: this.currentUser.id }) }
        if (this.items.creator && this.items.creator.name) { this.allUsersFromOrder.push({ name: this.items.creator.name, value: this.items.creator.id }) }
        if (this.items.optional_sales_manager) { this.allUsersFromOrder.push({ name: this.items.optional_sales_manager.name, value: this.items.optional_sales_manager.id }) }
        if (this.items.company && this.items.company.sales_manager) { this.allUsersFromOrder.push({ name: this.items.company.sales_manager.name, value: this.items.company.sales_manager.id }) }
        if (this.items.service_users.length) {
          this.items.service_users.forEach(user => {
            this.allUsersFromOrder.push({ name: user.user.name, value: user.user.id })
          })
        }
      }

      this.allUsersFromOrder = this.allUsersFromOrder.filter((user, index, self) => 
        index === self.findIndex((t) => (t.value === user.value && t.name === user.name)) && 
        user.value !== 1
      )
    },

    changeOrderScore(orderScore) {
      this.orderWidgetSetScore(orderScore)
    }
  },

  mounted() {
    this.refreshOrder();
    this.orderWidgetSetStatus("opened");
  },
};
</script>

<style lang="scss" scoped>
$bg-top: #0d6247;

.top {
  display: flex;
  align-items: flex-start;

  @media screen and (max-width: 991px) {
    position: relative;
    flex-wrap: wrap;
    padding-top: 5px;
  }
}

.buttons {
  margin-left: auto;
  @media screen and (max-width: 991px) {
    position: absolute;
    top: 5px;
    right: 0;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
}

.title {
  @media screen and (max-width: 991px) {
    font-size: 1rem;
    width: 100%;
  }
}

.subtitle {
  @media screen and (max-width: 991px) {
    margin-top: 14px;
    font-size: 1.1rem;
  }
}

.detail-widget {
  display: flex;
  position: absolute;
  width: 100%;
  height: 100%;
  background: #fff;

  @media screen and (max-width: 991px) {
    flex-direction: column;
    position: relative;
  }

  &__left {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    overflow-x: hidden;
    @media screen and (max-width: 991px) {
      min-height: 100vh;
    }
  }

  &__right {
    width: 100%;
    background-color: #f5f5f5;
    position: relative;
    @media screen and (max-width: 991px) {
      max-width: 100% !important;
    }

    &.collapses {
      transition: width 0.3s;
    }
  }

  &__top {
    position: relative;
    color: #fff;
    background-color: $bg-top;
    padding: 15px 1.5rem 15px 3rem;
    min-height: 110px;

    &-copy-button {
      position: absolute;
      top: 60px;
      left: 10px;
      border: none;
      outline: none;
      background-color: transparent;
      color: #fff;
    }
  }

  &__card {
    flex: 1;
    overflow-x: hidden;

    ::v-deep .tabs {
      display: flex;
      height: 100%;
      margin: 0;
      @media screen and (max-width: 991px) {
        flex-direction: column;
      }

      .nav-widget {
        background-color: $bg-top;
        height: 100%;
        flex-wrap: nowrap;
        overflow: auto;
        min-width: 130px;
        width: 100%;
        flex-direction: column;
        @media screen and (max-width: 991px) {
          flex-direction: row;
          height: auto;
          overflow-y: hidden;
        }
        .nav-link {
          text-align: left;
          border-radius: 0 !important;
          padding: 15px 10px !important;
          font-size: 14px !important;
          line-height: 1.1;
          font-weight: 700;
          color: #fff;
          min-width: 100px;
          border: none;
          text-transform: uppercase;
          @media screen and (max-width: 991px) {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            padding: 10px !important;
          }
          &.active {
            color: #000 !important;
            background-color: #fff;
          }
          &:hover {
            color: #000 !important;
            background: #fff;
          }
        }
      }

      .tab-content {
        overflow: auto;
        height: 100%;
        width: 100%;
        padding: 15px 22px;
        @media screen and (max-width: 991px) {
          overflow: inherit;
          padding: 15px 5px;
        }

        &::-webkit-scrollbar {
          width: 7px;
          border-radius: 0 !important;
        }
        &::-webkit-scrollbar-thumb {
          border-radius: 0 !important;
          cursor: pointer;
        }
      }
    }
  }

  &__back {
    font-size: 200%;
    position: absolute;
    left: 10px;
    top: 15px;
  }
}
</style>
